module.exports = __webpack_public_path__ + "static/media/pluto-fatal-error.2d38910a.png";